import React, { FC } from "react";
import { connect } from "react-redux";

import Progress from "antd/es/progress";
import { useIntl } from "react-intl";

import { formatFileSize } from "@mapmycustomers/shared/util/formatters";
import { Button } from "@mapmycustomers/ui";

import { getAllowedStorageForResources, isCurrentUserMember } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import { getStorageUsed } from "../../store";
import { STORAGE_UPGRADE_LINK } from "../../utils/const";

import messages from "./messages";
import styles from "./Sidebar.module.scss";

export interface StorageInfoProps {
  allowedStorageGb: number;
  isMember: boolean;
  storageUsedInBytes: number;
}

const StorageInfo: FC<StorageInfoProps> = ({ allowedStorageGb, isMember, storageUsedInBytes }) => {
  const intl = useIntl();

  const percent = (storageUsedInBytes * 100) / (allowedStorageGb * 1000 * 1000 * 1000);

  return (
    <div className={styles.storage}>
      <span className={styles.storageInfo}>
        {intl.formatMessage(messages.storageUsed, {
          b: (text) => <b>{text}</b>,
          current: formatFileSize(storageUsedInBytes, 1000),
          total: intl.formatNumber(allowedStorageGb, {
            style: "unit",
            unit: "gigabyte",
            unitDisplay: "narrow",
          }),
        })}
      </span>
      <Progress className={styles.progress} percent={percent} showInfo={false} />
      {percent >= 90 && (
        <>
          <span>
            {intl.formatMessage(percent < 100 ? messages.storageAlmostFull : messages.storageFull)}
          </span>
          {!isMember && (
            <div>
              <Button href={STORAGE_UPGRADE_LINK} target="_blank" type="primary">
                {intl.formatMessage(messages.upgrade)}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  allowedStorageGb: getAllowedStorageForResources(state),
  isMember: isCurrentUserMember(state),
  storageUsedInBytes: getStorageUsed(state),
});

export default connect(mapStateToProps)(StorageInfo);
